import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetMyWatchlistV1Request } from './get-my-watchlist-v1-request';
import {
  getMyWatchlistV1ResponseSchema,
  type IGetMyWatchlistV1Response,
} from './get-my-watchlist-v1-response';

export async function getMyWatchlistV1Api(
  params?: IGetMyWatchlistV1Request,
): Promise<IValidatedResponse<IGetMyWatchlistV1Response>> {
  const query = new URLSearchParams();
  if (params?.cursor) {
    query.set('cursor', params.cursor);
  }
  if (params?.limit) {
    query.set('limit', String(params.limit));
  }
  const qs = query.toString();

  return getRequest<IGetMyWatchlistV1Response>({
    path: qs ? `/user-collections/watchlist/v1?${qs}` : '/user-collections/watchlist/v1',
    schema: getMyWatchlistV1ResponseSchema,
  });
}
